
import React, { useState } from 'react';
import * as utils from "../components/utils.js";


function StringListEditor(props) {
    const { data, columnName, onChange, dataType = "string", dfuValue = "New element" } = props;
    const [_data, _setData] = useState(data);


    const _deleteRow = async (params) => {
        const { row } = params;
        _data.splice(_data.findIndex(x => x === row), 1);
        _notify_change();
    }

    const _notify_change = () => {
        _setData(utils.clone(_data));
        if (onChange) onChange(_data);
    }


    const _get_table_cell = (params) => {
        const { row_data, row_id } = params;
        const _getCellInput = (type) => {
            switch (type) {
                case "textarea":
                    return (<textarea className="form-control" rows="4" value={row_data}
                        onChange={(e) => {
                            _data[_data.findIndex(x => x === row_data)] = e.target.value;
                            _notify_change();
                        }}

                    ></textarea>)

                case "string":
                default: {
                    return (<input type="text" className="form-control" value={row_data}
                        onChange={(e) => {
                            _data[_data.findIndex(x => x === row_data)] = e.target.value;
                            _notify_change();
                        }}
                    ></input>)
                }
            }
        }

        const _td = (
            <td key="value">
                {_getCellInput(dataType)}
            </td>
        );

        return _td;
    }

    const _addStringToData = () => {
        _data.push(dfuValue);
        _notify_change();
    }

    const _get_table_row = (params) => {
        const { row_data } = params;
        const _cells = [];
        const row_id = `row_${data.findIndex(x => x === row_data)}`;        

        _cells.push(_get_table_cell({
            row_id,
            row_data
        }));


        _cells.push(
            (<td key="command" className="text-center" onClick={(e) => {
                _deleteRow({ row: row_data });
            }}>
                <i className="fa fa-trash fa-2x hover-icon-trash"></i>
            </td>)
        );        

        return (
            <tr key={row_id}>
                {_cells.map((c) => c)}
            </tr>
        );
    }


    return (
        <>
            <table className="table ">
                <thead>
                    <tr>
                        <th>{columnName}</th>
                    </tr>
                </thead>
                <tbody>
                    {_data.map(x => _get_table_row({
                        row_data: x, onChange: (e) => {

                        }
                    }))}
                </tbody>
            </table>
            <div className="row">
                <div className="d-grid gap-2 col md-6"> <button type="button" className="btn btn-primary" onClick={(e) => {
                    {
                        _addStringToData();
                    }
                }}>+</button></div>
            </div>
        </>
    );
}


export default StringListEditor